import React from 'react';
import RoundScoreRow from './RoundScoreRow';

import * as myConstClass from '../../shared/constants/constants';

class RoundScore extends React.Component {

  constructor(props) {
		super(props);
		//this.dummyfunction = this.dummyfunction.bind(this);
	}

	render() {
		// console.log('RoundScore: RENDER')
		// console.log(this.props.round)

		// copy first, not modifying the original matchups
		var sortedMatchups = JSON.parse(JSON.stringify(this.props.round.matchups));

		if (this.props.teamOrder === 'A') {
			sortedMatchups = sortedMatchups.sort((a, b) => (a.p1Index[0] - b.p1Index[0]));
		}
		if (this.props.teamOrder === 'B') {
			sortedMatchups = sortedMatchups.sort((a, b) => (a.p2Index[0] - b.p2Index[0]));
		}

		return (
			<div>               
				<div className="form-group">
				<div className="row">
				<div className="col-md-12">
					<h5>{this.props.round.description}</h5>
				</div>
				</div>
				</div>

				<div className="form-group">
				<div className="row">
				<div className="col-md-12">

					{sortedMatchups.map(function (matchup, i) {
					return (
						<RoundScoreRow key={"m"+i} matchup={matchup} 
							handleScoreChange={this.props.handleScoreChange} handleScoreBlur={this.props.handleScoreBlur}
							handleKeyPress={this.props.handleKeyPress} handleEroChange={this.props.handleEroChange}
							handleTbbChange={this.props.handleTbbChange} handleTvChange={this.props.handleTvChange}
							leagueType={this.props.leagueType} stateloLeagueParam={this.props.stateloLeagueParam}>
						</RoundScoreRow>
					);
					}, this)}

				</div>
				</div>
				
				<div className="row">
				<div className="col-md-6">

					<table className="table">
					<tbody>
						{this.displayTeamHandicap()}
						<tr>
							<td>Sous-total</td>
							<td>{this.props.round.team1Pts}</td>
							<td>{this.props.round.team2Pts}</td>
						</tr>
						<tr>
							<td>Cumulatif</td>
							<td>{this.team1CumulativePoints()}</td>
							<td>{this.team2CumulativePoints()}</td>
						</tr>
					</tbody>
					</table>

				</div>
				</div>
				</div>
			</div>
		);
	}

	displayTeamHandicap() {
		// Handicap per round
		if ((this.props.handicapType === "Cote TRS") ||
			  (this.props.handicapType === "Moyenne")) {

			return (
				<tr>
					<td>Handicap</td>
					<td>
						{/*<input className="form-control-sm" type="number" name="team1HandicapPts" value={this.props.team1HandicapPts || 0} 
							onChange={this.team1HandicapChange}></input>*/}
						{this.props.team1HandicapPts}
					</td>
					<td>
						{/*<input className="form-control-sm" type="number" name="team1HandicapPts" value={this.props.team2HandicapPts || 0} 
							onChange={this.team2HandicapChange}></input>*/}
						{this.props.team2HandicapPts}
					</td>
				</tr>
			);
		} else {
			return;
		}
	}

	team1CumulativePoints() {
		var cumulPoints = 0;
		for (var idx = 0; idx <= this.props.roundIdx; idx++) {
			cumulPoints += this.props.allRounds[idx].team1Pts;
		}
		return Math.round(cumulPoints * 100) / 100;
	}

	team2CumulativePoints() {
		var cumulPoints = 0;
		for (var idx = 0; idx <= this.props.roundIdx; idx++) {
			cumulPoints += this.props.allRounds[idx].team2Pts;
		}
		return Math.round(cumulPoints * 100) / 100;
	}

}

export default RoundScore;